export default __webpack_public_path__ + "static/media/4.9723e949.png";